import React, {Component} from 'react'

class JobTableHead extends Component {
    render() {
        return (
            <thead className='thead-light'>
            <tr>
                <th className="colNumber">#</th>
                <th>Session</th>
                <th>Tên lô</th>
                <th>Ngày tạo</th>
                <th>Trạng thái</th>
                <th className="text-center">Đang chờ / Đang chạy / Lỗi / Hoàn thành / Tổng</th>
                <th className="colAction">Hành động</th>
            </tr>
            </thead>
        )
    }
}

export default JobTableHead